export default __webpack_public_path__ + "static/media/view-history.cb56dd61.png";